<template>
    <div class="sl-search-bar">
        <div class="sl-search-types">
            <SearchBarButton v-if="state.buttons.locations" label="Certified Fitting Locations" search-type="locations" />            
            <SearchBarButton v-if="state.buttons.events" label="TaylorMade Fitting Events" search-type="events" />
            <SearchBarButton v-if="state.buttons.retailers" label="Retailers" search-type="retailers" />
        </div>

        <div v-if="state.appRegion == 'eu'" class="form-block">
            <InputSelect v-model="state.countryCode"
                         label="Country"
                         name="country_code"
                         :options="[
                             {value: 'AD', label: 'Andorra' },
                             {value: 'AT', label: 'Austria' },
                             {value: 'BE', label: 'Belgium' },
                             {value: 'CY', label: 'Cyprus' },
                             {value: 'CZ', label: 'Czech Republic' },
                             {value: 'DK', label: 'Denmark' },
                             {value: 'EE', label: 'Estonia' },
                             {value: 'FI', label: 'Finland' },
                             {value: 'FR', label: 'France' },
                             {value: 'DE', label: 'Germany' },
                             {value: 'GR', label: 'Greece' },
                             {value: 'GG', label: 'Guernsey' },
                             {value: 'IS', label: 'Iceland' },
                             {value: 'IE', label: 'Ireland' },
                             {value: 'IT', label: 'Italy' },
                             {value: 'JE', label: 'Jersey' },
                             {value: 'LT', label: 'Lithuania' },
                             {value: 'LU', label: 'Luxembourg' },
                             {value: 'MT', label: 'Malta' },
                             {value: 'MA', label: 'Morocco' },
                             {value: 'NL', label: 'Netherlands' },
                             {value: 'NO', label: 'Norway' },
                             {value: 'PO', label: 'Poland' },
                             {value: 'PT', label: 'Portugal' },
                             {value: 'SK', label: 'Slovakia' },
                             {value: 'ES', label: 'Spain' },
                             {value: 'CH', label: 'Switzerland' },
                             {value: 'SE', label: 'Sweden' },
                             {value: 'TR', label: 'Turkey' },
                             {value: 'GB', label: 'United Kingdom' }
                         ]" />
        </div>
    
        <div class="form-block">
            <div v-if="state.calculatingPostalCode" class="sl-calculating">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
                </svg>

                Calculating your {{ postalCodeName }} Code... <button type="button" @click="handleCancelPostalCodeCalculation">
                    Cancel
                </button>
            </div>
            <InputText v-model="state.searchPostalCode" name="search_code" :label="postalCodeName + ' Code'" :required="true" type="tel" @enter-key="search" />
        </div>

        <div class="form-block">
            <InputSelect v-model="state.searchDistance"
                         name="search_distance"
                         label="Distance"
                         :options="[
                             {value: 10, label: `10 ${state.distancePref}`}, 
                             {value: 25, label: `25 ${state.distancePref}`}, 
                             {value: 50, label: `50 ${state.distancePref}`}, 
                             {value: 100, label: `100 ${state.distancePref}`}
                         ]" />
        </div>

        <div class="submit-btn">
            <button class="btn btn-primary btn-block"
                    :class="{
                        'btn-disabled': !isButtonEnabled,
                    }"
                    :disabled="!isButtonEnabled"
                    @click="search">
                {{ searchBtnCta }}
            </button>
        </div>
    </div>
</template>

<script>
import SearchBarButton from './SearchBarButton';
import InputText from './InputText';
import InputSelect from './InputSelect';

export default {
    components: {
        SearchBarButton,
        InputText,
        InputSelect,
    },

    computed: {
        postalCodeFieldType () {
            if (this.state.countryCode.toUpperCase() == 'US') {
                return 'tel';
            }

            return 'text';
        },

        isButtonEnabled () {
            if (this.state.loading) {
                return false;
            }

            if (!this.state.searchPostalCode) {
                return false;
            }
            
            if (this.state.countryCode.toUpperCase() == 'US') {
                if (this.state.searchPostalCode.length > 5 || this.state.searchPostalCode.length < 4 || !Number.isInteger(parseInt(this.state.searchPostalCode))) {
                    return false;
                }
            }

            return true;
        },

        searchBtnCta () {
            if (!this.isButtonEnabled) return 'Enter your ' + this.postalCodeName + ' Code';
            
            if (this.state.loading) return 'One Moment...';
            
            if (this.state.searchType == 'locations') return 'Find a Fitting Location';

            if (this.state.searchType == 'events') return 'Find a Fitting Event';

            return 'Find a Retailer';
        }
    },

    methods: {
        search () {
            this.state.allowCalculatingPostalCode = false;
            this.state.calculatingPostalCode = false;
            this.$emit('search');
        },

        handleCancelPostalCodeCalculation () {
            this.state.allowCalculatingPostalCode = false;
            this.state.calculatingPostalCode = false;

            document.getElementById('search_code').focus();
        }
    }
};
</script>

<style scoped>
.sl-search-types {
    display: flex;
    margin-bottom: 15px;
}
.sl-search-bar {
    padding-bottom: 10px;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
}
.form-block {
    padding: 0 15px 15px;
    position: relative;
}
.submit-btn {
    padding: 0 15px 10px;
}
.sl-calculating {
    position: absolute;
    display: flex;
    top: 6px;
    right: 23px;
    z-index: 2;
    background: #ddd;
    color: #000;
    font-size: 12px;
    padding: 6px 20px 6px 10px;
    border-radius: 16px;
    align-items: center;
}
.sl-calculating svg {
    width: 17px;
    margin-right: 5px;
    animation-name: loading-spin;
    animation-duration: 4000ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
}
.sl-calculating button {
    appearance: none;
    display: inline;
    border: 0;
    background: none;
    padding: 0;
    margin: 0 0 0 5px;
    text-decoration: underline;
    color: black;
}
.sl-calculating button:hover {
    text-decoration: none;
}
@keyframes loading-spin {
    from {transform:rotate(0deg);}
    to {transform:rotate(360deg);}
}
</style>